<template>
  <div style="display: inline-block;">
    <span @click="show()" :id="'daigouOrder'+order.id">
      <slot></slot>
    </span>
    <el-dialog top="0" v-if="dialogFormVisible" class="el-dialog-sm custom-width-dialog-900" :close-on-click-modal="false" :modal="!mobiletype" :visible.sync="dialogFormVisible" width="90%" @close="init()">
      <div :class="{mobile_upload_order:mobiletype}">
      <h3 class="text-center">下单信息</h3>
      <el-form ref="form" :model="form" :rules="rules" class="dialog-form">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
        <div style="display:flex;justify-content: space-between;max-height: 73vh;">
          <div style="width:45%">
            <template v-if="order.type==2">
              <ul v-if="order.type==2" class="noBorder">
                <li v-for="(good,index) in goods_info"  class="good_info">
                  <el-row >
                    <el-col :span="6">
                        <img v-if="!good.image" src="../../../../ico/uploadpic@2x.png"  @click="showOrderVoucher(index)"/>
                        <img v-else :src="good.image"  @click="showOrderVoucher(index)"/>
                    </el-col>
                  </el-row>
                </li>
              </ul>
            </template>
            <template v-else>
              <div v-if="groupOrderLine.length==1 && groupOrderLine[0].number==1">
                <template v-if="groupOrderLine[0].editMode">
                  <div class="goods_info">
                    <div class="goods_info_row">
                      <img style="width:100px;height:100px;object-fit: contain;margin-bottom:10px;" :src="curItem.picture" />
                    </div>
                    <div class="goods_info_row" style="margin-bottom: 10px;position:relative;">
                      <el-input placeholder="商品图片网址" v-model="curItem.picture"></el-input>
                      <el-upload 
                        :action="API_HOST + '/api/order_v2.php?api=upload_picture'"
                        :on-success="handleUploadSuccess"
                        :headers="headers"
                        :before-upload="beforeUpload"
                        name="picture"
                        style="position:absolute;right:5px;top:10px;">
                        <el-button :disabled="isUploading" size="small" type="info">本地上传</el-button>
                      </el-upload>
                    </div>
                    <div class="goods_info_row">                    
                      <div class="goods_params">
                        <div class="goods_params_row">
                          <div style="display:flex;justify-content: space-between;margin-bottom:10px;">
                            <YueDanIpt style="width:75%;" model="name" :object="curItem" placeholder="商品名称"></YueDanIpt>
                            <YueDanIpt style="width:20%;" model="number" :object="curItem" placeholder="数量"></YueDanIpt>
                          </div>
                          <!--<div class="form_error" v-show="goodError.name || goodError.number" style="position: relative;top: -6px;height:16px;">
                              {{goodError.name?'商品名称是必填项':''}}
                          </div>-->
                          <div style="display:flex;justify-content: space-between;margin-bottom:10px;">
                            <YueDanIpt style="width:65%;" model="color" :object="curItem" placeholder="颜色等"></YueDanIpt>
                            <YueDanIpt style="width:30%;" model="size" :object="curItem" placeholder="尺码等"></YueDanIpt>
                          </div>
                          <!--<div class="form_error" v-show="goodError.price" style="position: relative;top: 2px;height:16px;">
                          </div>-->
                        </div>
                      </div>
                    </div>
                    <div class="goods_info_row">
                      <el-button class="nohover" style="width:48%;height:50px;" @click.stop="cancelGoods">取 消</el-button>
                      <el-button style="width:48%;height:50px;" type="info" @click.stop="confirmGoods">保 存</el-button>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div @click="showEdit(groupOrderLine[0])" style="cursor: pointer;">
                    <div class="img-container">
                      <img v-if="groupOrderLine[0].picture" :src="groupOrderLine[0].picture"/>
                      <img  v-else src="https://pic.joyorders.com/blank.png"/>
                    </div>
                    <div class="line-des">
                      <p class="name">{{groupOrderLine[0].name}}</p>
                      <p>
                        <span v-show="!groupOrderLine[0].isHideSpecLabel">规格：</span>
                        <span v-html="formatSpecNoLoopUpdate(groupOrderLine[0].spec,groupOrderLine[0])"></span>
                      </p>
                      <p><span>数量：</span>{{groupOrderLine[0].number}}</p>
                    </div>
                  </div>
                </template>
              </div>
              <div style="height:100%;" v-else>
                <ProductList ref="ProductList" :numEditable="false" :groupOrderLine="groupOrderLine" :order="order" :operation="'下单'"></ProductList>
              </div>
            </template>
          </div>
          <div style="width:45%">
            <el-form-item prop="content">
              <YueDanIpt model="content" :object="form" placeholder="私人备注"></YueDanIpt>
            </el-form-item>
            <el-form-item>
              <el-input type="textarea" :rows="3" placeholder="留言" v-model="form.member_content"></el-input>
            </el-form-item>
            <div>
              <!--<el-button :loading="loading" style="margin:20px 0 10px;" class="block" type="primary" @click="submitAndUpload()">提交并上传凭证</el-button>-->
              <el-button :loading="loading" style="margin-bottom:20px;" class="block" type="primary" @click="submit()">提 交</el-button>
            </div>
          </div>
        </div>      
      </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../../../services/api.js'
import YueDanIpt from '../../../../components/YueDanIpt'
import ProductList from './DaigouProductList'
import { SPEC_MAPPER,specOrder,API_HOST } from '../../../../services/constant.js'
import {showProductName,formatSpecNoLoopUpdate,formatSpec} from '../../../../services/tools.js'
let _ = require('lodash')

export default {
  name: 'DaigouOrder',
  props: ['order', 'isSingle','mobiletype','expressList','delegates','normal_address_show','totalAccountList'],
  components: {
    YueDanIpt: YueDanIpt,
    ProductList:ProductList
  },
  computed: {
  },
  data () {
    return {
      showProductName:showProductName,
      formatSpec:formatSpec,
      formatSpecNoLoopUpdate:formatSpecNoLoopUpdate,
      isUploading:false,
      API_HOST:API_HOST,
      groupOrderLine:[],
      goods_info:[],
      accountOptions:[],
      remoteAccountOptions:[],
      remoteTrasports:[],
      transport_delegate:'',
      seller_delegate:'',
      sellerdelegates:[],
      transportdelegates:[],
      settings:{},
      transport_express:'',
      transport_express_account:'',
      dialogFormVisible: false,
      isEmptyErrors: true,
      errors: null,
      form: {
        content: '',
        member_content:'',
      },
      headers:{},
      curItem:{},
      account_id:this.$localStorage.get('account_id'),
      loading: false,
      rules: {
        content: [
          // { required: true, message: '商家订单号是必填项', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    cancelGoods(){
      this.groupOrderLine[0].editMode=false
      this.$forceUpdate()
    },
    confirmGoods(){
      this.groupOrderLine[0]=JSON.parse(JSON.stringify(this.curItem))
      let obj={}
      let uni= this.groupOrderLine[0].unique_param?this.groupOrderLine[0].unique_param.replace('_list',''):''
      if(uni)
          obj[uni]=this.groupOrderLine[0][uni]
      if(this.groupOrderLine[0].vice_param)
          obj[this.groupOrderLine[0].vice_param]=this.groupOrderLine[0][this.groupOrderLine[0].vice_param]
      this.groupOrderLine[0].spec=JSON.stringify(obj)
      this.groupOrderLine[0].editMode=false
      this.$forceUpdate()
    },
    beforeUpload(){
      this.isUploading=true
    },
    handleUploadSuccess: function(response, file, fileList) {
      this.isUploading=false
      if (response.status !== 'ok') {
        this.$message.error('上传失败：'+response.result)
        return;
      }
      this.curItem.picture=response.result
      this.$forceUpdate()
    },
    showEdit(p){
      this.curItem=JSON.parse(JSON.stringify(p))
      p.editMode=true
      this.$forceUpdate()
    },
    show () {
      this.headers.token = this.$localStorage.get('token')
      let isModify=sessionStorage.getItem('isModifyUpload')
      this.dialogFormVisible = true
      this.$store.commit('updateOpenDialog', true)

      this.settings=JSON.parse(localStorage.getItem(this.account_id))
      if(!this.settings)
        this.settings={}
      if(this.order.order_no){
        this.form.content=this.order.order_no
      }

      this.groupOrderLine = []
      if(this.order.type==2){
        this.goods_info=[]
        this.order.good_image_list.forEach((g)=>{
          this.goods_info.push({id:new Date().getTime(),image:g,remark:''})
        })
      }
      else{
        let l = []
        if(this.$store.state.curPackageId)
          l = this.order.copy_goods_list.filter(i=>i.package_id == this.$store.state.curPackageId)
        else
          l = this.order.copy_goods_list
        //let l_copy=_.cloneDeep(l)
        //console.log('isqeual',l[0]==l_copy[0])
        _.each(l, item => {
          item.checked = false
          if (item.status == 0) {
            let obj={
              name:item.merchant_product_name || item.product_name,
              checked: item.checked,
              picture: item.merchant_product_image_url || item.product_image_url,
              spec:item.spec,
              number:item.number,
              brand_prefix_cn:item.brand_prefix_cn,
              name_cn:item.name_cn,
              unique_param:item.unique_param,
              vice_param:item.vice_param,
              website:item.website,
              discounted_price:item.discounted_price,
              product_name:item.product_name,
              product_image_url:item.product_image_url,
              merchant_product_name:item.merchant_product_name,
              merchant_product_image_url:item.merchant_product_image_url
            }
            let spec= JSON.parse(item.spec)
            let uni= item.unique_param?item.unique_param.replace('_list',''):''
            if(uni)
              obj.color=spec[uni]
            if(item.vice_param)
              obj.size=spec[item.vice_param]
            if(obj.spec.indexOf('spec:')==-1)
              obj.isHideSpecLabel=true
            else
              obj.isHideSpecLabel=false
            this.groupOrderLine.push(obj)
          }
        })
        if(this.groupOrderLine.length==1 && this.groupOrderLine[0].number==1){
          this.groupOrderLine[0].selectNum=1
          this.groupOrderLine[0].checked = true
        }
        //this.getpredata()
      }
    },
    getpredata() {
      let url=API_HOST+"/api/order.php?api=get_price_info&type=1";
      let params = {
        goods_list:this.groupOrderLine,
        type:this.order.type,
        service_type:this.order.service_type,
        merchant_id:this.order.business_id,
        address_id:this.order.address.id
      }
      this.$http.post(url,params).then(data =>{ 
          let result = data.body.result
          this.totalPrice=result.total_price
          if(result.transport_price.value=='0.00'){
            let obj={
              name:'运费',
              checked: true,
              picture: 'https://pic.joyorders.com/freight.png',
              spec:'运费',
              number:1,
              brand_prefix_cn:'',
              name_cn:'运费',
              //unique_param:item.unique_param,
              //vice_param:item.vice_param,
              //website:item.website,
              discounted_price:result.transport_price.value,
              product_name:'运费',
              product_image_url:'https://pic.joyorders.com/freight.png',
              merchant_product_name:'运费',
              merchant_product_image_url:'https://pic.joyorders.com/freight.png'
            }
            this.groupOrderLine.push(obj)
          }  
      })
    },
    init () {
      this.form.content = ''
      this.form.member_content = ''
      this.errors = null
      this.isEmptyErrors = true
      this.$store.commit('updateOpenDialog', false)
    },
    submitAndUpload(){
      this.submit(true)
    },
    submit(needUpload) {
      /*if(this.form.business_order_no){
        let reg = /[a-zA-Z0-9\-\.\_]+\b$/
        // let d = this.form.business_order_no
        if(!reg.test(this.form.business_order_no) || this.form.business_order_no.length >= 101 || this.form.business_order_no.indexOf('|')>-1){
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '请输入正确的商家订单号,必须包含字母或数字,可以包含-,_和.,不能包含|,不超过100个字符'}
            ]
          }
          return
        }
      }*/
      
      
      this.$refs['form'].validate(async (valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors

        if (valid) {
          let goods_list = []
          if(this.order.type==2){
            this.goods_info.forEach((line)=>{
              goods_list.push({
                id: line.id,
                num: 1
              })
            })
          }
          else{
            _.each(this.groupOrderLine, line => {
              if (line.checked) {
                goods_list.push({
                  image_url:line.picture,
                  name:line.name,
                  number: line.selectNum,
                  color:line.color,
                  url:line.website,
                  discounted_price:line.discounted_price,
                  size:line.size
                })
              }
            })
          }
          if(!goods_list.length){
            this.isEmptyErrors = false
            this.errors = {
              business_name: [
                {message: '请至少选择一件商品'}
              ]
            }
            return
          }
          let data={
              content: this.form.content,
              member_content: this.form.member_content,
              data:goods_list
            }
          console.log('data',data)
          //return
          let res = await api.post(this, {
            path: 'transport_company.php',
            api: 'create_fifteenhaoku_daigou_request',
            data: data,
            loading: 'loading'
          })
          res = res.body
          if(res.status == 'error'){
            this.isEmptyErrors = false
              this.errors = {
                business_name: [
                  {message: res.result}
                ]
              }
            return
          }
          if (res.status == 'ok') { 
            this.dialogFormVisible = false 
            let data = {
              status: null,
              operationType: '提交代购单成功,代购单号'+res.result.orderNo,
              operation: '代购',
              needRefreshPackStatus:false
            }     
            this.$emit('complete', data)
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .dialog-form {
    padding-bottom: 20px;
  }
  .tip {
    font-size: 12px;
    color: #888888;
    line-height: 16px;
  }
  .mobile_upload_order {
    padding: 0 10px !important;
  }
  .clearHistory{
    float: right;
    padding:0;
    font-size: 14px;
    color:#1066CF;
  }
  .img-container {
      float: left;
      width: 100px;
      height: 100px;
      overflow: hidden;
      img {
        width: 100px;
        height:100px;
        object-fit: contain;
      }
    }
    .line-des {
    margin-left: 130px;
    position: relative;
    top:-6px;
    p {
      line-height: 24px;
      word-break: break-all;
      span {
        color: #888888;
      }
    }
  }
  ul {
    margin-top: 10px;
    max-height: 286px;
    overflow-y: auto;
    overflow-x: hidden;
    &.noBorder{
      border-bottom:none !important;
    }
    .good_info{
      position: relative;
      border: 1px solid #ccc;
      margin-top: 20px;
      &:first-child{
        margin-top: 0px;
      }
      .delete {
        cursor: pointer;
        position: absolute;
        right: 6px;
        top: 10px;
      }
      img {
        padding: 10px;
        height: 90px;
        width: 90px;
        // -o-object-fit: contain;
        object-fit: contain;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/single/DaigouOrderDialog.vue